<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="450px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="success"
        v-on="on"
      >
        Create Tag
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Tag"
      text="Create Tag"
      class="mb-0"
    > 
      <form v-if="dialog">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="name"
                v-validate="'required'"
                :error-messages="errors.collect('name')"
                data-vv-name="name"                
                label="Name"
              />
            </v-col>
          </v-row>
        </v-container>
      </form>
      
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Create
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    inject: ['$validator'],
    data () {
      return {
        progressing: false,
        dialog: false,
        name: '',
      }
    },
    watch: {
      dialog: function (value) {
        if (value) {
          this.resetForm()
        }
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll().then((result) => {
          if (!result) return 

          this.progressing = true

          this.$api.tags().create({
            name: this.name,
          })
            .then(response => {
              this.$emit('created', response.data)
              this.$snack({ message: 'Added new job description tag' })

              this.dialog = false
            })
            .catch(() => {})
            .then(() => {
              this.progressing = false
            })
        })
      },
      resetForm () {
        this.name = ''
        this.$validator.reset()
      },
    },
  }
</script>
